/**
 * FAQ
 * @returns ReactElement
 */
import { Block } from '@/components/Block';
import { Page } from '@/config/track-config';
import { useScreenType } from '@/hooks/media';
import { Collapse, TextLink } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import classNames from 'classnames';

export function SectionFAQ(props: { showVideo: () => void }) {
  const fm = useFm();
  const { isMobile } = useScreenType();
  const items = [
    {
      label: fm('airdrop_faq_q1'),
      key: 1,
      children: (
        <div>
          <p
            className={classNames(['mb-3', isMobile && 'text-sm'])}
            dangerouslySetInnerHTML={{ __html: fm('airdrop_faq_a1') }}
          ></p>
          <TextLink
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              page_name: Page.AirdropArcadeHome,
              button_name: 'ViewVideo',
            })}
            onClick={props.showVideo}
          >
            {fm('viewIntroVideo')}
          </TextLink>
        </div>
      ),
    },
    {
      label: fm('airdrop_faq_q2'),
      key: 2,
      children: (
        <p
          className={classNames(isMobile && 'text-sm')}
          dangerouslySetInnerHTML={{ __html: fm('airdrop_faq_a2') }}
        ></p>
      ),
    },
    {
      label: fm('airdrop_faq_q3'),
      key: 3,
      children: (
        <span
          className={classNames(isMobile && 'text-sm')}
          dangerouslySetInnerHTML={{ __html: fm('airdrop_faq_a3') }}
        ></span>
      ),
    },
  ];
  return (
    <Block className="faq-wrap mt-4 !md:mt-20 relative" title={fm('FAQ')}>
      <Collapse
        items={items}
        collapsible={true}
        defaultValue={1}
        className={classNames(isMobile && 'collapse-h5')}
      />
    </Block>
  );
}
